/* eslint-disable import/prefer-default-export */
import { encryptWithPublicKey, importPublicKey } from './encryption';

/**
 * getEncryptedAnswers
 *
 * collects together data pertaining to the answers given by a customer. In order to protect any PII, these values are encrypted.
 */
export const getEncryptedAnswers = async (
  submissionAnswers,
  components,
  publicKeyString
) => {
  const publicKey = await importPublicKey(publicKeyString);
  const answersWithValues = Object.values(submissionAnswers).filter(
    (answer) =>
      typeof answer.value === 'object' && answer.value.some((value) => value)
  );

  // Format and encrypt values of answers object. Using this Promise/Entry pattern to accommodate for the asynchronous logic in the loop callback.
  const answersArray = await Promise.all(
    answersWithValues.map(async (answer) => {
      const componentId = answer.id;
      const answeredComponent = components[`component_${componentId}`];
      if (answeredComponent && answeredComponent?.component?.mappedQuestionId) {
        const value = await encryptWithPublicKey(
          answer.value.join(', '),
          publicKey
        );
        const { mappedQuestionId } = answeredComponent.component;
        return [componentId, { value, mappedQuestionId }];
      }
    })
  );
  return Object.fromEntries(answersArray.filter(Boolean));
};
